module.exports = __webpack_public_path__ + "static/tape-measure-b65d0bdd0c809298c4665e229965d9b3.gif";